import { PureComponent } from 'react'
import PropTypes from 'prop-types'
import ClipboardJS from 'clipboard'
import classNames from 'classnames'
import { CopyIcon } from 'components/icons'
import GhostLine from 'shared/GhostLine/GhostLine'

import css from './share-url.styles.scss'

class ShareUrl extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    label: PropTypes.string,
    url: PropTypes.string.isRequired,
  }

  state = {
    copied: false,
  }

  componentDidMount() {
    this.clipboard = new ClipboardJS('#copy-share-url')

    this.clipboard.on('success', (e) => {
      this.setState({
        copied: true,
      })
      setTimeout(() => {
        this.setState({
          copied: false,
        })
      }, 3000)
    })
  }

  render() {
    const { className, label, url } = this.props

    return (
      <div className={className}>
        {!!label && (
          <div className="h6 text-uppercase text-bold text-light tiny">
            {label}
          </div>
        )}
        <div
          id="copy-share-url"
          className="flex align-center pbm"
          data-clipboard-text={url}
        >
          <div
            id="share-url"
            className={classNames(css.urlWrapper, 'flex col h6 man grow prm')}
          >
            {!url && <GhostLine className="col-xs-12 ptl" />}
            {url && (
              <span className={css.url}>{url.replace(/^https?:\/\//, '')}</span>
            )}
          </div>
          {this.state.copied ? (
            <span className="h7 animated fadeIn animate-200ms">Copied!</span>
          ) : (
            <CopyIcon className="animated clickable fadeIn animate-500ms" />
          )}
        </div>
      </div>
    )
  }
}

export default ShareUrl
